import http from "@/utils/mpRequest"
//
export const get_server_expire_info= (code) => {
    return http.get("company/getServerExpireInfo?platformType="+code)
}
//缴费流水列表
export const get_payment_list = (data) => {
    return http.post("renewal/log/page",data)
}
export const add_payment = (data) => {
    return http.post("renewal/log/submit",data)
}
export const edit_payment = (data) => {
    return http.post("renewal/log/edit",data)
}
export const get_payment_detail = (id) => {
    return http.get("renewal/log/detail?id="+id)
}
//公司详情
export const get_company_detail = (id) => {
    return http.get("company/get_merchant_company_info?companyId="+id)
}
export const get_product_company_info = (id) => {
    return http.get("company/get_product_company_info?companyId="+id)
}
export const get_product_renewal_list = (id) => {
    return http.get("company/get_product_renewal_log_info?companyId="+id)
}

//
export const get_payment_type = () => {
    return http.get("enums/payment_type")    
}


export const get_renewal_method = () => {
    return http.get("enums/renewal_method")    
}

export const get_renewal_type = () => {
    return http.get("enums/renewal_type")    
}

export const get_renewal_status = () => {
    return http.get("enums/renewal_status")    
}

export const get_platform_type = () => {
    return http.get("enums/platform_type")    
}